import React, { useCallback, useEffect, useState } from "react";
import styles from "./category.module.css";
import { RxCross1 } from "react-icons/rx";
import { IoMdArrowDropdown, IoMdMail } from "react-icons/io";
import Select from "react-select";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { UsersApi } from "../../../App/api/users.api";
import MenuApi from "../../../App/api/menu.apis";
import selectDropdown from "../../../custom/SelectDropdown";
import { FaCity, FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { getAllCategory } from "../../../Pages/Menu/Category/HelperCategory";
import debounce from "lodash.debounce";

const CategoryModal = ({ setChangeStore, getAllVendorCategory }) => {
  const [serachVender, setSearchVender] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [cityData, setCityData] = useState();
  const [activeVendor, setActiveVendor] = useState(null);
  const [citySelected, setCitySelected] = useState(null);
  const [venderData, setVenderData] = useState([]);
  const [isfoodBusiness, setIsfoodBusiness] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: "",
  });

  const { value: countryData } = useFetchAll(() => MenuApi.getAllCountry());
  const { value: allBusinessTypeData } = useFetchAll(() =>
    MenuApi.getAllBusinesgetsType()
  );

  const options = selectDropdown(countryData?.data, "_id", "name");
  const cityOptions = selectDropdown(cityData, "_id", "name");

  const optionsAllBuisinessType = selectDropdown(
    allBusinessTypeData?.data,
    "_id",
    "name"
  );

  const fetchAllData = async () => {
    setVenderData([]); // Clear previous data
    // console.log("search Vender");
    const res = await getAllCategory(() => UsersApi.getAllVendor(pagination));
    // console.log("res", res?.data?.user);
    setVenderData(res?.data?.user); // Set new data
  };
  const fetchSearchVender = async (search) => {
    setVenderData([]); // Clear previous data
    // console.log("search Vender");
    const res = await getAllCategory(() =>
      UsersApi.getAllVendor(pagination, search)
    );
    // console.log("res", res?.data?.user);
    setVenderData(res?.data?.user); // Set new data
  };

  useEffect(() => {
    // Fetch data when pagination changes
    fetchAllData();
  }, [pagination]);

  const handleGellAllVendorCategory = async (venderId, data) => {
    const filter = {
      filter: {
        created_by: venderId,
      },
    };
    getAllVendorCategory(filter, data);
    setActiveVendor(venderId);
    setChangeStore(false);
  };

  const debouncedFetch = useCallback(
    debounce((query) => fetchSearchVender(query), 1000),
    [pagination]
  );

  const handleVenderSearchChange = (event) => {
    const query = event.target.value;
    setSearchVender(query);
    debouncedFetch(query);
  };

  const handleChange = async (selected) => {
    setSelectedOption(selected);
    setPagination((prev) => ({
      ...prev,
      filter: { country: selected?.value },
    }));

    try {
      const res = await MenuApi.getAllCity(selected.value);
      setCityData(res?.data?.data);
    } catch (error) {
      // console.log("error", error);
    }
  };

  const handleCityChange = (value) => {
    setPagination((prev) => ({
      ...prev,
      filter: { ...prev.filter, city: value?.value },
    }));
  };

  const handleBusinessChange = (value) => {
    console.log("value", value);

    setPagination((prev) => ({
      ...prev,
      filter: { ...prev.filter, delivery_business: value?.value },
    }));
  };

  return (
    <>
      <div className={styles.main}>
        <div className={styles.container}>
          <div className={styles.header_div}>
            <span style={{ fontSize: "1.4rem" }}>Select Store</span>
            <RxCross1
              size={"1rem"}
              cursor={"pointer"}
              onClick={() => setChangeStore(false)}
            />
          </div>
          <hr style={{ borderTop: "1px solid gray" }} />
          <div className={styles.select_header}>
            <div style={{ position: "relative" }}>
              <p style={{ fontSize: "1.3rem" }}>Country</p>
              <Select
                value={selectedOption}
                className={styles.profit_input1}
                id={styles.selet}
                options={options}
                onChange={handleChange}
              />
              <IoMdArrowDropdown
                size={"1.1rem"}
                style={{
                  position: "absolute",
                  top: "3.5rem",
                  right: "1rem",
                }}
              />
            </div>
            <div style={{ position: "relative" }}>
              <p style={{ fontSize: "1.3rem" }}>City</p>
              <Select
                className={styles.profit_input1}
                id={styles.selet}
                options={cityOptions}
                onChange={handleCityChange}
                placeholder="Select business type"
              />
              <IoMdArrowDropdown
                size={"1.1rem"}
                style={{
                  position: "absolute",
                  top: "3.5rem",
                  right: "1rem",
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              padding: "1rem",
              alignItems: "center",
              marginLeft: "0.8rem",
            }}
          >
            <input
              type="text"
              value={serachVender}
              className={styles.inputs}
              onChange={handleVenderSearchChange}
              placeholder="Search"
            />
            <div style={{ position: "relative" }}>
              <Select
                className={styles.profit_input2}
                id={styles.selet}
                options={optionsAllBuisinessType}
                onChange={handleBusinessChange}
                placeholder="Select business"
              />
              <IoMdArrowDropdown
                size={"1.1rem"}
                style={{
                  position: "absolute",
                  top: "1.7rem",
                  right: "1rem",
                }}
              />
            </div>
          </div>
          {venderData.length === 0 && (
            <p style={{ textAlign: "center", marginTop: "1.8rem" }}>
              No Stores Found....
            </p>
          )}

          <div
            style={{ padding: "2rem", marginTop: "0.5rem", cursor: "pointer" }}
          >
            {venderData?.map((data) => {
              const isActive = data._id === activeVendor;
              return (
                <div
                  className={`${styles.list__container} ${
                    isActive ? styles.active : ""
                  }`}
                  key={data._id}
                  onClick={() => handleGellAllVendorCategory(data?._id, data)}
                >
                  <div>
                    <p
                      style={{
                        fontSize: "1.2rem",
                        textTransform: "capitalize",
                      }}
                    >
                      {data.first_name || "No Name"}
                    </p>
                    <p style={{ fontSize: "0.9rem", marginTop: "5px" }}>
                      <p className={styles.store_details_p}>
                        <FaLocationDot />
                        {data?.country.name}
                      </p>
                    </p>
                    <p style={{ fontSize: "0.9rem", marginTop: "5px" }}>
                      <p className={styles.store_details_p}>
                        <FaCity />
                        {data?.city?.name}
                      </p>
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "end",
                    }}
                  >
                    <p className={styles.store_details_p}>
                      <FaPhoneAlt />
                      {data?.phone_number || "No Contact"}
                    </p>
                    <p className={styles.store_details_p}>
                      <IoMdMail />
                      {data?.email || "No Email"}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryModal;
